"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TreeSet = _interopRequireDefault(require("../../../../java/util/TreeSet"));

var _LineString = _interopRequireDefault(require("../geom/LineString"));

var _hasInterface = _interopRequireDefault(require("../../../../hasInterface"));

var _MultiPoint = _interopRequireDefault(require("../geom/MultiPoint"));

var _GeometryGraph = _interopRequireDefault(require("../geomgraph/GeometryGraph"));

var _GeometryCollection = _interopRequireDefault(require("../geom/GeometryCollection"));

var _Polygonal = _interopRequireDefault(require("../geom/Polygonal"));

var _RobustLineIntersector = _interopRequireDefault(require("../algorithm/RobustLineIntersector"));

var _LinearComponentExtracter = _interopRequireDefault(require("../geom/util/LinearComponentExtracter"));

var _TreeMap = _interopRequireDefault(require("../../../../java/util/TreeMap"));

var _MultiLineString = _interopRequireDefault(require("../geom/MultiLineString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var IsSimpleOp =
/*#__PURE__*/
function () {
  function IsSimpleOp() {
    _classCallCheck(this, IsSimpleOp);

    IsSimpleOp.constructor_.apply(this, arguments);
  }

  _createClass(IsSimpleOp, [{
    key: "isSimpleMultiPoint",
    value: function isSimpleMultiPoint(mp) {
      if (mp.isEmpty()) return true;
      var points = new _TreeSet.default();

      for (var i = 0; i < mp.getNumGeometries(); i++) {
        var pt = mp.getGeometryN(i);
        var p = pt.getCoordinate();

        if (points.contains(p)) {
          this._nonSimpleLocation = p;
          return false;
        }

        points.add(p);
      }

      return true;
    }
  }, {
    key: "isSimplePolygonal",
    value: function isSimplePolygonal(geom) {
      var rings = _LinearComponentExtracter.default.getLines(geom);

      for (var i = rings.iterator(); i.hasNext();) {
        var ring = i.next();
        if (!this.isSimpleLinearGeometry(ring)) return false;
      }

      return true;
    }
  }, {
    key: "hasClosedEndpointIntersection",
    value: function hasClosedEndpointIntersection(graph) {
      var endPoints = new _TreeMap.default();

      for (var i = graph.getEdgeIterator(); i.hasNext();) {
        var e = i.next();
        var maxSegmentIndex = e.getMaximumSegmentIndex();
        var isClosed = e.isClosed();
        var p0 = e.getCoordinate(0);
        this.addEndpoint(endPoints, p0, isClosed);
        var p1 = e.getCoordinate(e.getNumPoints() - 1);
        this.addEndpoint(endPoints, p1, isClosed);
      }

      for (var i = endPoints.values().iterator(); i.hasNext();) {
        var eiInfo = i.next();

        if (eiInfo.isClosed && eiInfo.degree !== 2) {
          this._nonSimpleLocation = eiInfo.getCoordinate();
          return true;
        }
      }

      return false;
    }
  }, {
    key: "getNonSimpleLocation",
    value: function getNonSimpleLocation() {
      return this._nonSimpleLocation;
    }
  }, {
    key: "isSimpleLinearGeometry",
    value: function isSimpleLinearGeometry(geom) {
      if (geom.isEmpty()) return true;
      var graph = new _GeometryGraph.default(0, geom);
      var li = new _RobustLineIntersector.default();
      var si = graph.computeSelfNodes(li, true);
      if (!si.hasIntersection()) return true;

      if (si.hasProperIntersection()) {
        this._nonSimpleLocation = si.getProperIntersectionPoint();
        return false;
      }

      if (this.hasNonEndpointIntersection(graph)) return false;

      if (this._isClosedEndpointsInInterior) {
        if (this.hasClosedEndpointIntersection(graph)) return false;
      }

      return true;
    }
  }, {
    key: "hasNonEndpointIntersection",
    value: function hasNonEndpointIntersection(graph) {
      for (var i = graph.getEdgeIterator(); i.hasNext();) {
        var e = i.next();
        var maxSegmentIndex = e.getMaximumSegmentIndex();

        for (var eiIt = e.getEdgeIntersectionList().iterator(); eiIt.hasNext();) {
          var ei = eiIt.next();

          if (!ei.isEndPoint(maxSegmentIndex)) {
            this._nonSimpleLocation = ei.getCoordinate();
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "addEndpoint",
    value: function addEndpoint(endPoints, p, isClosed) {
      var eiInfo = endPoints.get(p);

      if (eiInfo === null) {
        eiInfo = new EndpointInfo(p);
        endPoints.put(p, eiInfo);
      }

      eiInfo.addEndpoint(isClosed);
    }
  }, {
    key: "computeSimple",
    value: function computeSimple(geom) {
      this._nonSimpleLocation = null;
      if (geom.isEmpty()) return true;
      if (geom instanceof _LineString.default) return this.isSimpleLinearGeometry(geom);
      if (geom instanceof _MultiLineString.default) return this.isSimpleLinearGeometry(geom);
      if (geom instanceof _MultiPoint.default) return this.isSimpleMultiPoint(geom);
      if ((0, _hasInterface.default)(geom, _Polygonal.default)) return this.isSimplePolygonal(geom);
      if (geom instanceof _GeometryCollection.default) return this.isSimpleGeometryCollection(geom);
      return true;
    }
  }, {
    key: "isSimple",
    value: function isSimple() {
      this._nonSimpleLocation = null;
      return this.computeSimple(this._inputGeom);
    }
  }, {
    key: "isSimpleGeometryCollection",
    value: function isSimpleGeometryCollection(geom) {
      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var comp = geom.getGeometryN(i);
        if (!this.computeSimple(comp)) return false;
      }

      return true;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IsSimpleOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "isSimple",
    value: function isSimple() {
      if (arguments.length === 1) {
        var geom = arguments[0];
        var op = new IsSimpleOp(geom);
        return op.isSimple();
      } else if (arguments.length === 2) {
        var _geom = arguments[0],
            boundaryNodeRule = arguments[1];
        var op = new IsSimpleOp(_geom, boundaryNodeRule);
        return op.isSimple();
      }
    }
  }]);

  return IsSimpleOp;
}();

exports.default = IsSimpleOp;

var EndpointInfo =
/*#__PURE__*/
function () {
  function EndpointInfo() {
    _classCallCheck(this, EndpointInfo);

    EndpointInfo.constructor_.apply(this, arguments);
  }

  _createClass(EndpointInfo, [{
    key: "addEndpoint",
    value: function addEndpoint(isClosed) {
      this.degree++;
      this.isClosed |= isClosed;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this.pt;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EndpointInfo;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return EndpointInfo;
}();

EndpointInfo.constructor_ = function () {
  this.pt = null;
  this.isClosed = null;
  this.degree = null;
  var pt = arguments[0];
  this.pt = pt;
  this.isClosed = false;
  this.degree = 0;
};

IsSimpleOp.EndpointInfo = EndpointInfo;

IsSimpleOp.constructor_ = function () {
  this._inputGeom = null;
  this._isClosedEndpointsInInterior = true;
  this._nonSimpleLocation = null;

  if (arguments.length === 1) {
    var geom = arguments[0];
    this._inputGeom = geom;
  } else if (arguments.length === 2) {
    var _geom2 = arguments[0],
        boundaryNodeRule = arguments[1];
    this._inputGeom = _geom2;
    this._isClosedEndpointsInInterior = !boundaryNodeRule.isInBoundary(2);
  }
};